import { render, staticRenderFns } from "./VesselGeneratedWaste.vue?vue&type=template&id=0d875501"
import script from "./VesselGeneratedWaste.vue?vue&type=script&lang=js"
export * from "./VesselGeneratedWaste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports